import React from "react";
import "./Hero.css";

const Hero = () => {
  return (
    <div className="hero-img container">
      <div className="hero-content">
        <h1 className="heading-primary">
          Welcome to <span> Austin's Bar-B-Que</span>
        </h1>
        <p className="text-white">Premium Texas BBQ Catering and Dine-In</p>
        <p></p>
      </div>
    </div>
  );
};

export default Hero;
